import { useEffect, useState } from 'react'
import { fetchBrand } from 'repos/brand'
import { useSelector } from 'react-redux'
import { State } from 'index'
import { getBrandRef } from 'reducks/auth/selectors'

const useFetchBrandName = () => {
  const brandRef = useSelector((state: State) => getBrandRef(state))

  const [brandName, setBrandName] = useState<string>('')

  useEffect(() => {
    ;(async () => {
      if (!brandRef) return
      const brand = await fetchBrand(brandRef.id)
      if (!brand) return
      setBrandName(brand.name)
    })()
  }, [brandRef])

  return brandName
}

export default useFetchBrandName
